import ComponentOverview from 'components/ComponentOverview';
import React from 'react';
export default {
  ComponentOverview,
  React
};